<template>
	<div class="group-main-div">
		<div class="search-bar-div div-border-top-1">
			<div style="flex: 1">
				<el-input v-model="search.searchText" placeholder="输入ASIN或者组名搜索" clearable></el-input>
			</div>
			<div style="margin-left: 15px">
				<el-button @click="searchFun(null)" :disabled="loading">
					<span v-if="loading" class="el-icon-loading"></span>
					<span v-else class="el-icon-search"></span>
				</el-button>
				<el-button type="primary" @click="addMonitor(null)" >添加监控</el-button>
			</div>
		</div>
		<div class="table-main-box" v-loading="loading" >
			<el-table ref="elTable"  :data="searchData.list" height="100%"
				:header-cell-style="{'background-color' : '#F9F9F9'}"
				tooltip-effect="dark" @selection-change="handleSelectionChange">
<!--				<el-table-column type="selection" width="55"></el-table-column>-->
				<el-table-column label="#" width="50px" align="center">
					<template slot-scope="scope">
						<span class="color-text-grey-2"> {{ scope.$index + 1 }} </span>
					</template>
				</el-table-column>
				<el-table-column label="名称" align="center" min-width="350px">
					<template slot-scope="scope">
						<div v-if="scope.row.edit">
							<el-input size="mini" v-model="scope.row.inputValue"
								class="name-input-20230323" @change="updateGroupName(null,scope.$index)"
								:ref="'updateName' + scope.$index" >
								<el-button @click="updateGroupName(null,scope.$index)"
									slot="append" icon="el-icon-edit-outline" size="mini"></el-button>
							</el-input>
						</div>
						<div v-else style="display: flex;" >
							<div class="overflow-one-line" style="overflow-x: hidden;margin-right: 5px;cursor: pointer;"
								@click="startNameEdit(scope.$index)">
								<i class="el-icon-edit"></i>
								{{ scope.row.name }}
							</div>
							<span>
								<copy-sub :value="scope.row.name"></copy-sub>
							</span>
						</div>
					</template>
				</el-table-column>
				<el-table-column label="商品预览" header-align="center" width="880px" fit >
					<template slot-scope="scope">
						<div class="asin-preview-box">
							<div v-for="(item,index) in scope.row.asins"
								:key="scope.$index + ':' + index" class="asin-div div-border-1">
								{{ void(asinInfo=asinInfoList.find(i => i.asin === item) || { asin : item }) }}
								<div>
									<asin-sub :show-rank="false" :asin-info="asinInfo">
										<el-image style="width: 70px; aspect-ratio:1/1;" :preview-src-list="asinInfo.imgs" lazy
											scroll-container=".el-table__body-wrapper"
											:src="imgSizeSet(asinInfo.imgs ? asinInfo.imgs[0] : '',70)" :fit="'scale-down'">
											<div slot="error" style="line-height:70px;font-size: 12px;text-align: center;font-family:monospace;">
												{{ item }}
											</div>
										</el-image>
									</asin-sub>
								</div>
							</div>
						</div>
					</template>
				</el-table-column>
				<el-table-column label="商品数量" width="80" align="center" prop="asinTotal"></el-table-column>
				<el-table-column label="关键词数量" width="90" align="center">
					<template slot-scope="scope">
						{{ scope.row.keywords.length }}
<!--						<el-popover	placement="right"  trigger="hover">-->
<!--							<div style="max-height:200px;padding-right:10px; overflow-y: auto">-->
<!--								<p :key="index" v-for="(keywords,index) in scope.row.keywords">-->
<!--									<span > {{ keywords }} </span>-->
<!--									<copy-sub  :value="keywords"></copy-sub>-->
<!--								</p>-->
<!--							</div>-->
<!--							<span slot="reference" class="underline-dashed-line">{{ scope.row.keywords.length }}</span>-->
<!--						</el-popover>-->
					</template>
				</el-table-column>
				<el-table-column label="创建日期" width="100" align="center">
					<template slot-scope="scope">
						<span>{{ $timezone(scope.row.createTime, 'HH:mm:ss') }}</span>
						<br/>
						<span>{{ $timezone(scope.row.createTime, 'YYYY-MM-DD') }}</span>
					</template>
				</el-table-column>
				<el-table-column width="90" align="center" fixed="right">
					<template slot-scope="scope">
						<el-button type="text" @click="checkedKeywordList(scope.row.id,scope.row.name)" size="small">详情</el-button>
						<el-button type="text" @click="delGroup(null,scope.row.id)" size="small">删除</el-button>
					</template>

				</el-table-column>
			</el-table>
		</div>
		
		<div class="main-page-div">
			<page-sub :background="true" layout="prev, pager, next"
				@current-change="pageChange" :total="searchData.total" :page-size="search.pageSize"
				:current-page="search.page"/>
		</div>

		<el-dialog title="添加商品" :show-close="false" destroy-on-close append-to-body width="1100px" top="80px"
			:visible.sync="addMonitorObj.visible" v-if="addMonitorObj.visible" custom-class="el-dialog-20230321">
			<div slot="title" style="text-align: right;">
				<el-button @click="addMonitorObj.visible=false" type="danger" icon="el-icon-close"
					size="mini"></el-button>
			</div>

			<div v-if="addMonitorObj.visible">
				<div>
					<add-monitor-sub @success="(v) => {addMonitorObj.visible = v;loadData(null)}"></add-monitor-sub>
				</div>
			</div>
		</el-dialog>

	</div>
</template>

<script>
import {
	api_groupDel_monitoring2,
	api_groupPage_monitoring2,
	api_groupRename_monitoring2
} from "@/components/api/keywordsMonitoring2";
import { imgSizeSet } from "@/components/common/utils/imgUtils";
import PAGE_SUB from "@/components/template/otherSub/pageSub";
import COPY_SUB from "@/components/template/otherSub/copySub";
import ASIN_INFO_SUB from "@/components/template/view/keywordsTrend/sub/asinInfoPopoverSub";
import ADD_MONITORING_SUB from "@/components/template/view/keyword/monitoring2/keyword/addKeywords";
import da from "element-ui/src/locale/lang/da";
import { api_asin_batchAsinInfoQuery_public, api_findeByAsin } from "@/components/api/asinBasiceInfo";

export default {
	name: "groupList",
	inject: ['WINDOW', 'F_alertMsg', 'F_windowLoading', 'F_getErrMSg', 'F_LOGIN', 'LOGINUSER','KEYWORD_ADD_TAB'],
	data() {
		return {
			windowObj: this.WINDOW,
			loginUser: this.LOGINUSER,
			loading : false,
			search : {
				page : 1,
				pageSize : 10,
				searchText : null
			},
			searchData : {
				list : []
			},
			//  asin数据
			asinInfoList : [],
			loadAsinLock : false,
			// 添加asin 操作版配置
			addMonitorObj : {
				visible : false
			},// 修改组配置
			updateConfig: {
				dialogVisible: false,
				loading: false,
				data : null
			},
		};
	},
	components : {
		'copy-sub' : COPY_SUB,
		'page-sub': PAGE_SUB,
		'asin-sub': ASIN_INFO_SUB,
		'add-monitor-sub' : ADD_MONITORING_SUB
	},
	created() {
		this.$options.methods.loadData(this)
	},
	methods: {
		handleSelectionChange : function(val) {
			
		},
		startNameEdit : function(index) {
			let obj = { ...this.$data.searchData.list[index] }
			obj.edit = true
			obj.inputValue = obj.name
			this.$set(this.$data.searchData.list,index,obj)

		},
		pageChange: function(val) {
			this.$data.search.page = val
			this.$options.methods.loadData(this)
		},
		searchFun : function(this_){
			this_ = this_ || this
			this_.$data.search.page = 1
			this_.$options.methods.loadData(this_)
		},
		updateGroupName : function(this_,rowId) {
			this_ = this_ || this
			let obj = { ...this_.$data.searchData.list[rowId] }
			if (obj.name ===  obj.inputValue){
				obj.edit = false
				this.$set(this.$data.searchData.list,rowId,{ ...obj} )
				return
			}
			api_groupRename_monitoring2(obj.id,obj.inputValue).then(res => {
				obj.edit = false
				obj.name = obj.inputValue
				this.$set(this.$data.searchData.list,rowId,obj)
				this_.F_alertMsg( '修改成功', 2)
			}).catch(err => {
				obj.loading = false
				this.$set(this.$data.searchData.list,rowId,obj)
				this_.F_alertMsg(this_.F_getErrMSg(err, '修改失败'), 4)
			})
		},
		loadData : function(this_) {
			this_ = this_ || this
			if (this_.$data.loading){
				return
			}
			let obj = { ...this_.$data.search }
			this_.$data.loading = true //  开启遮罩
			api_groupPage_monitoring2(obj).then(res => {
				this_.$data.loading = false //  关闭遮罩
				this_.$data.searchData = res.data
				this_.$nextTick(() => {
					this_.$options.methods.loadAsinInfo(this_)
				})
			}).catch(err => {
				this_.$data.loading = false //  关闭遮罩
				this_.F_alertMsg(this_.F_getErrMSg(err, '删除失败'), 4)
			})
		},
		loadAsinInfo : function(this_) {
			this_ = this_ || this
			let asins = new Set();
			this_.$data.searchData.list.forEach(i => {
				i.asins.forEach(asin => {
					asins.add(asin)
				})
			})
			if(asins.size <= 0 || this_.$data.loadAsinLock){
				return
			}
			// 上锁
			this_.$data.loadAsinLock = true
			api_asin_batchAsinInfoQuery_public([...asins]).then(res => {
				let data = res.data || []
				this_.$data.asinInfoList = data
				// 解锁
				this_.$data.loadAsinLock = false
			}).catch(err => {
				// 解锁
				this_.$data.loadAsinLock = false
				console.error(err)
			})
		},
		delGroup : function(this_,groupId) {
			this_ = this_ || this
			if (this_.$data.loading){
				return
			}
			this_.$confirm('此操作将永久删除, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this_.$data.loading = true //  开启遮罩
				api_groupDel_monitoring2(groupId).then(res => {
					this_.$data.loading = false //  关闭遮罩
					this_.F_alertMsg('删除成功', 2)
					this_.$options.methods.loadData(this_)
				}).catch(err => {
					this_.$data.loading = false //  关闭遮罩
					this_.F_alertMsg(this_.F_getErrMSg(err, '删除失败'), 4)
				})
			}).catch(() => {
				this_.F_alertMsg('取消删除', 2)
			});
		},
		checkedKeywordList : function(groupId,name) {
			let this_ = this
			let sub = () => import('@/components/template/view/keyword/monitoring2/keyword/list')
			this.KEYWORD_ADD_TAB(null,name, 'keywordsList-' + groupId,sub,{ groupId : groupId })
		},
		addMonitor: function(this_) {
			this_ = this_ || this
			this_.$data.addMonitorObj.visible = true
			// let sub = () => import('@/components/template/view/keyword/monitoring2/keyword/addKeywords')
			// this_.KEYWORD_ADD_TAB(null, '添加监控', 'addMonitor', sub)
		},
		imgSizeSet : function(url,size=100) {
			return imgSizeSet(url,size)
		},
	}, watch: {
		windowObj: {
			handler() {
			},
			deep: true
		},
		loginUser: {
			handler() {
			},
			deep: true
		}
	}
}
</script>

<style scoped>
.group-main-div{
	display: flex;
	flex-direction: column;
	height: 100%;
}
.search-bar-div{
	display: flex;
	text-align: right;
	line-height: 70px;
	padding: 0 10px;
}
.table-main-box{
	position: absolute;
	top: 70px;
	left: 0;
	right: 0;
	bottom: 64px;
}

/*商品预览*/
.el-table-20220806 .asin-preview-box{
	font-size: 12px;
}
.asin-preview-box > div{
	vertical-align: top;
	display: inline-block;
	text-align: center;
	margin: 0 5px;
}
.asin-preview-box .asin-div{
	padding: 2px;
	box-sizing: border-box;
}
.main-page-div{
	text-align: center;
	position: absolute;
	padding: 15px;
	left: 0;
	right: 0;
	bottom: 0;
}
</style>
<style>
.name-input-20230323 .el-input-group__append{
	padding: 0 15px;
}
.el-dialog-20230321 .el-dialog__body{
	padding: 0 20px;
}
</style>